// Analytics — thin wrapper over window.gtag (GA4). No-op when gtag is absent,
// so we can sprinkle .track() calls without worrying about dev environments.

type EventParams = Record<string, string | number | boolean | null | undefined>

declare global {
  interface Window {
    gtag?: (command: "event" | "config" | "set" | "consent", eventName: string, params?: EventParams) => void
    dataLayer?: unknown[]
  }
}

export const Analytics = {
  track(eventName: string, params: EventParams = {}): void {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params)
      return
    }

    // Helpful in development: log the event so we can see what would have been
    // sent. Drops silently in production builds because nobody's looking.
    if (typeof console !== "undefined" && console.debug) {
      console.debug("[analytics]", eventName, params)
    }
  },
}
